/* import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form'; */
import useErrors from 'hooks/useErrors';
import { contractService } from 'services';
import { useQuery } from '@tanstack/react-query';

const useContract = () => {
 const { setError } = useErrors();
 const { getContracts } = contractService.useApiContracts();

 const { data } = useQuery(
  {
   queryKey: ['contracts'],
   queryFn: getContracts,
   onSuccess: data => console.log(data),
   onError: err => setError(err)
  },
  { staleTime: Infinity }
 );

 return { data };
};

export default useContract;
